import { FIXED_ACTION_TYPES } from '+/models/ActionsStore';
import actionProfiles from '+/models/actionProfiles';
import TextReader from '+/utils/TextReader';

export const getActionOptions = (allActionTypeMappings, allActionTypeTemplates, textReaderTemplate) => {
  const { t } = new TextReader(textReaderTemplate);

  const requiredActions = allActionTypeMappings?.store.filter(action => action.required);

  const requiredActionsFixed = requiredActions.filter(object => FIXED_ACTION_TYPES.includes(object.actionType)).map(object => object.actionType);

  const requiredActionsCustom = requiredActions
    .filter(object => !FIXED_ACTION_TYPES.includes(object.actionType))
    .map(object => object.actionTypeTemplateId);

  const fixedTypeOptions = Object.keys(actionProfiles).map(name => ({
    name: `${name}Enabled`,
    label: t(`labels.${name}`),
    alphabeticOrder: name.toLowerCase(),
    required: requiredActionsFixed.includes(name),
  }));

  const customTypeOptions = allActionTypeTemplates.map(template => ({
    name: `customActionTypesEnabled#${template.id}`,
    label: template.preferenceActionPhrase,
    alphabeticOrder: template.label.toLowerCase(),
    required: requiredActionsCustom.includes(template.id),
  }));

  const sortOptions = (a, b) => {
    if (a.name === 'otherEnabled') return 1;
    if (b.name === 'otherEnabled') return -1;
    return a.alphabeticOrder < b.alphabeticOrder ? -1 : 1;
  };

  const allOptions = fixedTypeOptions.concat(customTypeOptions);
  const optionalOptions = allOptions.filter(option => !option.required).sort(sortOptions);
  const requiredOptions = allOptions.filter(option => option.required).sort(sortOptions);

  return { optionalOptions, requiredOptions, allOptions, customTypeOptions };
};
